import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FreightSearchService {
  constructor(private http: HttpClient) {}

  /**
   * search freight
   */
  searchFreight(searchParams: any): Observable<any> {
    const url = `${environment.wpgApiUrl}/estimateCharge/searchFreight`;
    return this.http.post(url, searchParams);
  }

  /**
   * get freight excel
   */
  getFreightExcel(searchParams: any): Observable<any> {
    const url = `${environment.wpgApiUrl}/estimateCharge/getFreightExcel`;
    return this.http.post(url, searchParams, { responseType: 'blob' });
  }
}
